/**
 *  Determines whether nil should be considered the smallest/largest value or should always be the last value when sorting
 */
export enum NilSorting {
	SMALLEST,
	LARGEST,
	LAST
}
